module.exports = __webpack_public_path__ + "img/dream_stream.7bc8331a.jpg";